import { css } from '@design.estate/dees-element';

export const viewerStyles = css`
  :host {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: var(--dees-font-family);
  }

  .viewer-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: var(--dees-color-bg-primary);
  }

  .toolbar-title {
    font-size: 13px;
    font-weight: 500;
    color: var(--dees-color-text-secondary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  .time-display {
    font-size: 13px;
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    color: var(--dees-color-text-secondary);
    min-width: 90px;
    flex-shrink: 0;
  }

  .volume-group {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .volume-slider { width: 70px; accent-color: var(--dees-color-accent-primary); }
  .content-area {
    min-height: 0;
    gap: 20px;
    flex-direction: column;
    flex: 1;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .waveform-container {
    position: relative;
    width: min(80%, 600px);
    height: 120px;
    cursor: pointer;
    overflow: hidden;
  }

  .waveform-container canvas {
    width: 100%;
    height: 100%;
    display: block;
  }

  .content-area { padding: 24px; }
  .content-area .media-seek { width: min(80%, 600px); flex: 0 0 auto; }
  .waveform-playhead { position: absolute; top: 0; bottom: 0; width: 2px; background: var(--dees-color-accent-primary); pointer-events: none; }
  .audio-symbol { font-size: 56px; color: var(--dees-color-text-muted); }
  .waveform-note { font-size: 12px; color: var(--dees-color-text-secondary); text-align: center; }
  .error-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: var(--dees-color-text-muted);
  }

  .error-overlay .error-icon {
    color: var(--dees-color-text-error);
    font-size: 32px;
  }

  .error-text {
    font-size: 13px;
  }

  .loading-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid var(--dees-color-border-strong);
    border-top-color: var(--dees-color-link);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
